import initialState from './initialState'

const ADD_DISCOUNT = function(state) {
    let newDiscount = {
        quantity: '',
        discountType: '',
        discount: '',
    }
    if(state.globalPercentageDiscount){
        newDiscount.discountType = 1
        
    }
    state.arrayDiscounts.push(newDiscount)
    state.arrayDiscounts = [...state.arrayDiscounts]
}

const DELETE_DISCOUNT = function(state, index) {
    state.arrayDiscounts.splice(index, 1)
    state.arrayDiscounts = [...state.arrayDiscounts]

}

const SET_QUANTITY = function(state, payload) {
    state.arrayDiscounts[payload.index].quantity = payload.quantity
    state.arrayDiscounts = [...state.arrayDiscounts]
}

const SET_DISCOUNT_TYPE = function(state, payload) {
    state.arrayDiscounts[payload.index].discountType = payload.discountType
    state.arrayDiscounts = [...state.arrayDiscounts]
}

const SET_DISCOUNT = function(state, payload) {
    state.arrayDiscounts[payload.index].discount = payload.discount
    state.arrayDiscounts = [...state.arrayDiscounts]
}

const SET_MAX_PRICE_DISCOUNT = function(state, payload) {
    state.maxPriceDiscount = payload
}

const SET_ID = function(state, id) {
    state.id = id
}

const RESET_ARRAY_DISCOUNTS = async function(state) {
    state.arrayDiscounts.length = 0
    let newDiscount = {
        quantity: '',
        discountType: '',
        discount: '',
    }
    if(state.globalPercentageDiscount){
        newDiscount.discountType = 1
        
    }
    state.arrayDiscounts.push(newDiscount)

    state.arrayDiscounts = [...state.arrayDiscounts]

    state.arrayDiscountsUploads++
    
}

const SORT_DISCOUNTS_BY_QUANTITY = function(state) {
    state.arrayDiscounts.sort(function(a, b) {
        return parseInt(a.quantity) - parseInt(b.quantity)
    })
    state.arrayDiscounts = [...state.arrayDiscounts]
}


const SET_INITIAL_ARRAY_DISCOUNTS = function(state, payload) {
    state.arrayDiscounts.length = 0
    state.prevArrayDiscounts.length = 0
    let auxArray = []
    for(let i = 0; i < payload.length; i++){
        let discount = {}
        if(payload[i].percentage_discount === 0){ // Price discount ($)
            discount = {
                quantity: payload[i].quantity_discount.toString(),
                discountType: 2,
                discount: payload[i].unit_price_discount.toString(),
            }
        }else{ // Percentage discount (%)
            discount = {
                quantity: payload[i].quantity_discount.toString(),
                discountType: 1,
                discount: payload[i].percentage_discount.toString(),
            }
        }
        //state.arrayDiscounts.push(discount)
        auxArray.push(discount)
    }

    // state.arrayDiscounts.sort(function(a, b) { // sorting auxArrayDiscount by quantity
    //     return parseInt(a.quantity) - parseInt(b.quantity)
    // })
    auxArray.sort(function(a, b) { // sorting auxArrayDiscount by quantity
        return parseInt(a.quantity) - parseInt(b.quantity)
    })

    // for(let i = 0; i < state.arrayDiscounts.length; i ++){
    //   let current = Object.assign({}, state.arrayDiscounts[i]);
    //   state.prevArrayDiscounts.push(current)
    // }
    // state.arrayDiscounts = [...state.arrayDiscounts]
    // state.prevArrayDiscounts = [...state.arrayDiscounts]
    // state.arrayDiscountsUploads++
    state.arrayDiscounts = [...auxArray]
    state.prevArrayDiscounts = [...auxArray]
}

const RESTART_EDITING = function(state) {
    state.arrayDiscounts.length = 0
    // for(let i = 0; i < state.prevArrayDiscounts.length; i++){
    //     let discount = {
    //             quantity: state.prevArrayDiscounts[i].quantity,
    //             discountType: state.prevArrayDiscounts[i].discountType,
    //             discount: state.prevArrayDiscounts[i].discount,
    //         }
    //     state.arrayDiscounts.push(discount)
    // }
    state.arrayDiscounts = [...state.prevArrayDiscounts]
    state.arrayDiscountsUploads++

}

const UPLOADED_ARRAY_DISCOUNTS = function(state){
    state.arrayDiscountsUploads = state.arrayDiscountsUploads + 1
}

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())

}

const SET_GLOBAL_PERCENTAGE_DISCOUNT = function(state, payload) {
    state.globalPercentageDiscount = payload
}

export default {
    RESET_STATE,
    SET_QUANTITY,
    ADD_DISCOUNT,
    SET_DISCOUNT_TYPE,
    SET_DISCOUNT,
    SET_MAX_PRICE_DISCOUNT,
    SET_ID,
    DELETE_DISCOUNT,
    SORT_DISCOUNTS_BY_QUANTITY,
    RESET_ARRAY_DISCOUNTS,
    SET_INITIAL_ARRAY_DISCOUNTS,
    RESTART_EDITING,
    UPLOADED_ARRAY_DISCOUNTS,
    SET_GLOBAL_PERCENTAGE_DISCOUNT,
}
